
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
#container {
  overflow: auto;
  border-radius: 0.5rem;
}

@media (min-width: 768px){
  #overlay.medium #container{
    max-height:95vh;
    max-width:75vw;
  }

  #container {
    border-width: 4px;
  }

  #container {
    border-style: solid;
  }

  #container {
    border-color: var(--gray-professional-main);
  }
}

#header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-top: 2rem;
}

@media (min-width: 640px) {

  #header {
    align-items: baseline;
  }
}

@media (min-width: 1024px) {

  #header {
    flex-direction: row;
  }
}

.heading {
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  text-align: center;
  font-size: var(--fs-xl);
  line-height: var(--lh-xl);
  font-weight: var(--fw-semibold);
  color: var(--blue-responsible-main);
}

@media (min-width: 640px) {

  .heading {
    margin-top: 1rem;
  }

  .heading {
    text-align: left;
  }

  .heading {
    font-size: var(--fs-3xl);
    line-height: var(--lh-3xl);
  }
}

#main {
  padding-top: 0px;
}

#main, #header {
  padding-left: 2rem;
  padding-right: 2rem;
}

@media (min-width: 1024px) {

  #main, #header {
    padding-left: 8vw;
    padding-right: 8vw;
  }
}

#close {
  top: 0.75rem;
  right: 0.75rem;
  margin-top: 1rem;
}

#close:before {
  cursor: pointer;
}

#close:before {
  border-radius: 9999px;
}

#close:before {
  background-color: var(--blue-responsible-lighten-1);
}

#close:before {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

#close:before {
  padding-left: 0.6rem;
  padding-right: 0.6rem;
}

#close:before {
  font-family: Open Sans, Helvetica, Arial, sans-serif;
}

#close:before {
  color: var(--neutral-white);
}

#close:before{
    content:'X';
  }
`;